import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { addComma } from "../../../utils/addComma";
import { LoadingPage } from "../../LoadingPage/LoadingPage";
import { useHistory } from "react-router";
import { showPrice } from "../../../utils/priceFunc";
//ICON's
import styles from "./LayoutCoin.module.scss";
import PolygonGreen from "../../../styles/icon/polygon_green.svg";
import PolygonBlue from "../../../styles/icon/polygon_blue.svg";
import ArrowBackIcon from "../../../styles/icon/arrow_back_fill.svg";

export default function LayoutCoin({ children }) {
  const coin = useSelector((state) => state.coinInfo.data);
  const loadingBar = useSelector((state) => state.loadingBar.loading);
  const history = useHistory();
  const orderType = history.location.pathname.split("/")[1];
  return (
    <>
      {loadingBar && <LoadingPage />}
      <div className={styles.container}>
        <div className={styles.back_btn}>
          <img
            src={ArrowBackIcon}
            alt="BACK"
            width={15}
            height={15}
            onClick={() => history.goBack()}
          />
        </div>
        <div className={styles.header_container}>
          <div className={styles.coin_pic}>
            <img
              src={`/images/assets-logo/${coin?.symbol}.png`}
              alt={coin?.symbol}
              width={65}
              height={65}
            />
          </div>
          <div className={`font_color_white ${styles.coin_name}`}>
            {coin?.name}({coin?.symbol})
          </div>
          <div className={`font_color_white ${styles.coin_price}`}>
            ${showPrice(coin?.usdtPrice)}
          </div>
          <div className={styles.LineOfPage}></div>
        </div>
        <div className={`font_color_white ${styles.coin_information}`}>
          <div
            className={` changeBackgroundToGreen font_color_white ${styles.persian_coin_name}`}
          >
            {coin?.faName}
          </div>
          <div
            className={`${styles.coin_24H_changes} ${
              coin?.percent_change_24h > 0
                ? styles.coin_change_positive
                : styles.coin_change_negative
            }`}
          >
            {coin?.percent_change_24h}%
          </div>
          <Link to={`/about-coin/${coin?.symbol}`}>
            <div className={styles.description_button}>توضیحات</div>
          </Link>
          <div className={`font_color_white ${styles.description_item}`}>
            <div className={styles.polygon_place}>
              <img src={PolygonGreen} alt="" width={7} height={7} />
            </div>
            <div className={styles.title_info_place}>قیمت:</div>
            <div className={styles.desc_info_place}>
              <div
                style={{ display: "inline-block" }}
                className={styles.symbol_place}
              >
                تومان
              </div>
              <div
                className={styles.after_symbol_info}
                style={{ display: "inline-block" }}
              >
                {addComma(
                  orderType === "buy"
                    ? coin?.arzfi_price
                    : coin?.arzfi_buy_price
                )}
              </div>
            </div>
          </div>
          <div className={`font_color_white ${styles.description_item}`}>
            <div className={styles.polygon_place}>
              <img src={PolygonBlue} alt="" width={7} height={7} />
            </div>
            <div className={styles.title_info_place}>حجم بازار:</div>
            <div className={styles.desc_info_place}>
              <div
                style={{ display: "inline-block" }}
                className={styles.symbol_place}
              >
                $
              </div>
              <div
                className={styles.after_symbol_info}
                style={{ display: "inline-block" }}
              >
                {coin?.marketcap}
              </div>
            </div>
          </div>
          <div className={`font_color_white ${styles.description_item}`}>
            <div className={styles.polygon_place}>
              <img src={PolygonBlue} alt="" width={7} height={7} />
            </div>
            <div className={styles.title_info_place}>معاملات روزانه:</div>
            <div className={styles.desc_info_place}>
              <div
                style={{ display: "inline-block" }}
                className={styles.symbol_place}
              >
                $
              </div>
              <div
                className={styles.after_symbol_info}
                style={{ display: "inline-block" }}
              >
                {coin?.volume24h}
              </div>
            </div>
          </div>
          <div className={`font_color_white ${styles.description_item}`}>
            <div className={styles.polygon_place}>
              <img src={PolygonBlue} alt="" width={7} height={7} />
            </div>
            <div className={styles.title_info_place}>سکه در گردش:</div>
            <div className={styles.desc_info_place}>
              <div
                style={{ display: "inline-block" }}
                className={styles.symbol_place}
              >
                {coin?.symbol}
              </div>
              <div
                className={styles.after_symbol_info}
                style={{ display: "inline-block" }}
              >
                {coin?.circulationSup}
              </div>
            </div>
          </div>
          <div className={`font_color_white ${styles.description_item}`}>
            <div className={styles.polygon_place}>
              <img src={PolygonBlue} alt="" width={7} height={7} />
            </div>
            <div className={styles.title_info_place}>عرضه کل:</div>
            <div className={styles.desc_info_place}>
              <div
                style={{ display: "inline-block" }}
                className={styles.symbol_place}
              >
                {coin?.symbol}
              </div>
              <div
                className={styles.after_symbol_info}
                style={{ display: "inline-block" }}
              >
                {coin?.totalSup}
              </div>
            </div>
          </div>
          <div className={`font_color_white ${styles.description_item}`}>
            <div className={styles.polygon_place}>
              <img src={PolygonBlue} alt="" width={7} height={7} />
            </div>
            <div className={styles.title_info_place}>رتبه:</div>
            <div className={styles.desc_info_place}>
              <div
                style={{ display: "inline-block" }}
                className={styles.symbol_place}
              >
                #
              </div>
              <div
                className={styles.after_symbol_info}
                style={{ display: "inline-block" }}
              >
                {coin?.cmcRank}
              </div>
            </div>
          </div>
        </div>
        <div>{children}</div>
      </div>
    </>
  );
}
